export const BrFormFieldVariants = Object.freeze({
    SoftInset: 'softInset',
    Neumorphic: 'neumorphic',
    Auth: 'auth'
});

export type BrFormFieldVariant = (typeof BrFormFieldVariants)[keyof typeof BrFormFieldVariants];
